import React from 'react';
import './Owner.css';

const Owner = ({ content }) => (
  <div className="owner-container">
    <section className="owner">
      <div className="owner__copy"><h2 className="owner__title">{content.title}</h2><div className="owner__underline"></div>{content.paragraphs.map((paragraph) => <p className="owner__description" key={paragraph}>{paragraph}</p>)}</div>
      <figure className="owner__media"><div className="owner__image-wrapper"><img src={content.image.src} alt={content.image.alt} loading="lazy" className="owner__image" /></div></figure>
    </section>
  </div>
);

export default Owner;

